import { createProductAdsAPIClient } from './productAdsAPIClient';

export const productAdsAPIClient = createProductAdsAPIClient();
